// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608041534/js/" + chunkId + "." + {"44":"8fe0e51c","225":"9d7519f0","481":"532b0ae6","486":"2a698892","770":"40a97d17"}[chunkId] + ".0.8655015122048192.chunk.js";
};